import React from 'react';
import WatchReview from '../watchReview'


function Mother(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/P85sQAWi5PQ" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign films. Over our next drink, we discuss 'Mother'."
            />
        )
    }   

export default Mother;
